import {SERVER_MESSAGE, CLIENT_MESSAGE} from "@redbrick-sdk/multiplay-common";

const freezingHandler = {
  defineProperty(target, property, descriptor) {
    return;
  },
  deleteProperty(target, property) {
    return;
  },
  preventExtensions(target) {
    return;
  },
  set(target, property, value) {
    return;
  },
  setPrototypeOf(target, prototype) {
    return;
  },
};

class EventManager {
  static #room = null;
  static #eventCallbacks = {};
  static #players = {};

  static setRoomInstance(room) {
    this.#room = room;
    room.onMessage(SERVER_MESSAGE.SERVER_SCRIPT_EVENT, message => {
      if (this.#eventCallbacks[message.name] === undefined) return;
      this.#eventCallbacks[message.name].forEach(callback => callback(message.params));
    });
    this.#players = new Proxy(room.players, freezingHandler);
  }

  get players() {
    return EventManager.#players;
  }

  send(name, params) {
    if (!EventManager.#room) return;
    EventManager.#room.send(CLIENT_MESSAGE.CLIENT_SCRIPT_EVENT, {name, params});
  }

  // [NOTE] Use 'arrow function' as a callback function to retain the lexical context's 'this' value, not the execution context's 'this'.
  addListener(name, callback) {
    if (typeof callback !== "function") return;
    if (EventManager.#eventCallbacks[name] === undefined) EventManager.#eventCallbacks[name] = [];
    EventManager.#eventCallbacks[name].push(callback);
  }

  removeListener(name, callback) {
    if (EventManager.#eventCallbacks[name] === undefined) return;
    const idx = EventManager.#eventCallbacks[name].indexOf(callback);
    if (idx !== -1) EventManager.#eventCallbacks[name].splice(idx, 1);
    // Is there remove onMessage method?
    // https://discuss.colyseus.io/topic/332/can-i-remove-one-handle-in-onmessage/2
    // EventManager.#room.onMessage.remove(name);
  }
}

export default EventManager;
